import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import {
  LookUpElement,
  VirtualUser,
} from 'src/app/shared/models/common-data.model';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { LookupsService } from 'src/app/shared/services/lookups.service';
import { VirtualUserSharedService } from 'src/app/shared/services/virtual-user-shared.service';
import { VirtualUserService } from 'src/app/shared/services/virtual-user.service';

@Component({
  selector: 'app-virtual-user-edit',
  templateUrl: './virtual-user-edit.component.html',
  styleUrls: ['./virtual-user-edit.component.sass'],
})
export class VirtualUserEditComponent {
  modalRef: BsModalRef;
  virtualUser: any;
  teamSearch: string = '';
  dataSubject: Subscription;
  @Input() companyId: string;
  virtualUserForm: FormGroup;
  isLoading: boolean = false;
  virtualUserReq: VirtualUser;
  teamLookup: LookUpElement[] = [];
  @ViewChild('template', { static: true }) template: any;
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);
  @Output() dataEmitter: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private lookupsService: LookupsService,
    private helpersService: HelpersService,
    private translateService: TranslateService,
    private virtualUserService: VirtualUserService,
    private virtualUserSharedService: VirtualUserSharedService
  ) {
    this.dataSubject = virtualUserSharedService
      .getSubjectVirtualUserEditModal()
      .pipe(takeUntil(this.destroy))
      .subscribe((virtualUser: any) => {
        if (virtualUser) {
          this.virtualUser = virtualUser;
          this.showModal();
          this.getTeamLookUp();
          this.mapFormData();
        }
      });
  }

  ngOnDestroy(): void {
    this.modalRef?.hide();
    this.destroy.next(null);
    this.dataSubject.unsubscribe();
    this.virtualUserSharedService.setSubjectVirtualUserEditModal(null);
  }

  ngOnInit(): void {
    this.editVirtualUserForm();
  }

  private showModal() {
    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-dialog-right modal-lg',
    });
  }

  editVirtualUserForm() {
    this.virtualUserForm = this.fb.group({
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      UserName: ['', Validators.required],
      TeamId: [null, Validators.required],
    });
  }

  mapFormData() {
    this.virtualUserForm = this.fb.group({
      FirstName: [this.virtualUser.firstName, Validators.required],
      LastName: [this.virtualUser.lastName, Validators.required],
      UserName: [this.virtualUser.userName, Validators.required],
      TeamId: [this.virtualUser.teamId, Validators.required],
    });
  }

  cancelForm() {
    this.modalRef?.hide();
    this.virtualUserForm?.reset();
    this.virtualUserSharedService.setSubjectVirtualUserEditModal(null);
  }

  editVirtualUser(formData: any) {
    this.setReqBody(formData);
    this.saveVirtualUserInDB();
  }

  setReqBody(formData: any) {
    this.virtualUserReq = {
      id: this.virtualUser.id,
      teamId: formData.TeamId,
      userName: formData.UserName.trim(),
      lastName: formData.LastName.trim(),
      firstName: formData.FirstName.trim(),
    };
  }

  saveVirtualUserInDB() {
    this.isLoading = true;
    this.virtualUserService.updateVirtualUser(this.virtualUserReq).subscribe(
      (res: any) => {
        if (res) {
          if (res) {
            this.assignVirtualUser(true);
          }
          this.cancelForm();
          this.helpersService.showUpdateSuccessToast();
          this.virtualUserSharedService.setSubjectVirtualUserEditModal(null);

          this.isLoading = false;
        }
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  getTeamLookUp() {
    this.lookupsService
      .getTeamLookUp(null, this.companyId)
      .pipe(takeUntil(this.destroy))
      .subscribe((teamLookup: LookUpElement[]) => {
        this.teamLookup = teamLookup;
      });
  }

  assignVirtualUser(flag: boolean) {
    this.dataEmitter.emit(flag);
  }
}
